import React, { useState } from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function ClosingSection() {
  const [addScripts, setAddScripts] = useState(false);
  return <section id="pricing" className="py-20 px-6 bg-white border-t border-[#D4C5A9]/30" data-id="element-1">
      <div className="max-w-[720px] mx-auto" data-id="element-2">
        {/* The Quiet Truth */}
        <div className="text-center mb-20 fade-in-up" data-id="element-3">
          <h2 className="text-3xl font-serif font-bold text-[#2B4257] mb-8" data-id="element-4">
            The Quiet Truth
          </h2>
          <p className="text-xl text-[#5A5A5A] mb-4 leading-relaxed" data-id="element-5">
            You don't want to leave your kids a mess.
          </p>
          <p className="text-xl text-[#5A5A5A] mb-8 leading-relaxed" data-id="element-6">
            You also don't want your kids deciding what your life meant.
          </p>
          <p className="text-lg text-[#5A5A5A] mb-4" data-id="element-7">
            This is the middle path:
          </p>
          <p className="text-2xl font-bold text-[#2B4257] font-serif" data-id="element-8">
            You decide. You finish. You keep your dignity.
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-[#FAFAF7] border border-[#D4C5A9] rounded-xl overflow-hidden shadow-2xl mb-16 fade-in-up delay-100" data-id="element-9">
          <div className="bg-[#2B4257] p-6 text-center" data-id="element-10">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-11">
              Premium Edition
            </h3>
            <p className="text-[#D4C5A9] text-sm uppercase tracking-widest font-semibold" data-id="element-12">
              Instant Download
            </p>
          </div>

          <div className="p-8 md:p-10" data-id="element-13">
            {/* Product image near pricing */}
            <div className="flex justify-center mb-8" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/f67FWbbiHeJ8AHtQ4vmje8/heylloyd-image-1771090466847.png" alt="Downsizing Without Regret Premium Edition" className="w-48 rounded-lg shadow-lg border border-[#D4C5A9]/30" data-id="element-15" />
            </div>

            {/* Savings badge */}
            <div className="text-center mb-4" data-id="element-16">
              <span className="inline-block bg-[#6B9B8A] text-white text-base font-bold px-4 py-1.5 rounded-full uppercase tracking-wide text-center" data-id="element-17">
                Save 84% — You save $32.64
              </span>
            </div>

            <div className="flex justify-center items-baseline mb-2" data-id="element-18">
              <span className="text-5xl font-bold text-[#2B4257]" data-id="element-19">$6.36</span>
              <span className="text-[#5A5A5A] ml-2 text-base" data-id="element-20">one-time</span>
            </div>
            <div className="flex justify-center items-center mb-8" data-id="element-21">
              <span className="text-xl text-[#5A5A5A] line-through" data-id="element-22">$39</span>
              <span className="text-base text-[#6B9B8A] font-semibold ml-2" data-id="element-23">
                Launch Price
              </span>
            </div>

            <div className="space-y-4 mb-8" data-id="element-24">
              <p className="text-center text-[#5A5A5A] font-medium text-base" data-id="element-25">
                If this saves you even:
              </p>
              <ul className="space-y-2 text-base text-[#5A5A5A] max-w-xs mx-auto" data-id="element-26">
                <li className="flex items-center" data-id="element-27">
                  <ShieldCheck className="w-5 h-5 text-[#6B9B8A] mr-2 flex-shrink-0" data-id="element-28" />
                  One weekend of conflict
                </li>
                <li className="flex items-center" data-id="element-29">
                  <ShieldCheck className="w-5 h-5 text-[#6B9B8A] mr-2 flex-shrink-0" data-id="element-30" />
                  One panicked "we have to do this now" blowup
                </li>
                <li className="flex items-center" data-id="element-31">
                  <ShieldCheck className="w-5 h-5 text-[#6B9B8A] mr-2 flex-shrink-0" data-id="element-32" />
                  One month of background stress
                </li>
              </ul>
              <p className="text-center text-[#2B4257] font-bold mt-4 text-base" data-id="element-33">
                ...it paid for itself.
              </p>
            </div>

            {/* Order Bump */}
            <div className="bg-white border-2 border-dashed border-[#D4C5A9] p-4 rounded-lg mb-8 hover:border-[#6B9B8A] transition-colors cursor-pointer" onClick={() => setAddScripts(!addScripts)} data-id="element-34">
              <div className="flex items-start" data-id="element-35">
                <input type="checkbox" checked={addScripts} onChange={() => setAddScripts(!addScripts)} className="mt-1 h-5 w-5 text-[#2B4257] rounded border-gray-300 focus:ring-[#2B4257]" data-id="element-36" />
                <div className="ml-3" data-id="element-37">
                  <p className="text-[#2B4257] font-bold text-base" data-id="element-38">
                    Add the "Scripts Pack" (Printable) —{' '}
                    <span className="text-[#6B9B8A]" data-id="element-39">$1.47</span>
                    <span className="text-[#5A5A5A] line-through text-sm ml-2" data-id="element-40">
                      $9
                    </span>
                  </p>
                  <p className="text-sm text-[#5A5A5A] mt-1" data-id="element-41">
                    One-page word-for-word phrases for spouse, kids, and
                    yourself so downsizing doesn't turn into debate court.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA instruction */}
            <p className="text-center text-[#5A5A5A] text-base mb-4" data-id="element-42">
              Download the PDF. Print the three pages. Put them on the wall.
            </p>

            <a href="https://www.betterbysteps.com/cart/44199683784797:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#2B4257] text-white text-center font-bold text-xl py-4 rounded-lg shadow-lg hover:bg-[#1f3040] hover:shadow-xl hover:-translate-y-0.5 transition-all active:scale-[0.99] mb-6" data-id="element-43">
              Get Downsizing Without Regret — $6.36
            </a>

            {/* Guarantee Badge */}
            <div className="bg-[#6B9B8A]/10 border border-[#6B9B8A]/30 rounded-lg p-4 mb-6 text-center" data-id="element-44">
              <div className="flex items-center justify-center mb-2" data-id="element-45">
                <ShieldCheck className="w-5 h-5 text-[#6B9B8A] mr-2" data-id="element-46" />
                <h4 className="font-bold text-[#2B4257] text-base" data-id="element-47">
                  100% Peace-of-Mind Guarantee
                </h4>
              </div>
              <p className="text-sm text-[#5A5A5A] leading-relaxed" data-id="element-48">
                If you open the playbook and feel it's not right for your
                situation, email us and we'll make it right. No forms. No hoops.
                No guilt.
              </p>
            </div>

            <div className="flex justify-center items-center text-sm text-[#5A5A5A]" data-id="element-49">
              <Lock className="w-4 h-4 mr-1" data-id="element-50" />
              Secure 256-bit SSL Encrypted Checkout
            </div>
          </div>
        </div>

        {/* Footer */}
      </div>
    </section>;
}